export function projectScreenRegion(region, source, target) {
  const {x,y,width,height}=region ?? {};
  if (![x,y,width,height,source?.width,source?.height,target?.width,target?.height].every(Number.isFinite) ||
      source.width<=0 || source.height<=0 || target.width<=0 || target.height<=0 ||
      x<0 || y<0 || width<=0 || height<=0 || x+width>source.width || y+height>source.height)
    throw new Error("The fixed layer must fit its authored screen.");
  if(source.width===target.width && source.height===target.height)return {...region};
  const scale=Math.min(target.width/source.width,target.height/source.height);
  const w=Math.max(1,Math.min(target.width,Math.round(width*scale)));
  const h=Math.max(1,Math.min(target.height,Math.round(height*scale)));
  const left=source.width===width?Math.floor((target.width-w)/2):Math.round(x/(source.width-width)*(target.width-w));
  const top=source.height===height?Math.floor((target.height-h)/2):Math.round(y/(source.height-height)*(target.height-h));
  return {x:Math.max(0,Math.min(target.width-w,left)),y:Math.max(0,Math.min(target.height-h,top)),width:w,height:h};
}

export function projectScreenOverlays(item,source,target) {
  const result=structuredClone(item);
  if(result.staticOverlays!=null){
    result.staticOverlays=result.staticOverlays.map(visual=>({...visual,region:projectScreenRegion(visual.region,source,target)}));
    delete result.staticOverlay;
  }else if(result.staticOverlay){
    result.staticOverlay.region=projectScreenRegion(result.staticOverlay.region,source,target);
  }
  return result;
}
